document.addEventListener( 'DOMContentLoaded', function () {
  // Index project slider
  const ourproj_slide = document.querySelector('#ourproj_slide');
  if (ourproj_slide){
      new Splide('#ourproj_slide', {
      type   : 'loop',
      drag   : 'free',
      focus  : 'center',
      perPage: 5,
      gap: '20px',
      arrows: false,
      pagination: false,
      pauseOnHover: false,
      autoScroll: {
          speed: 1,
      },
      breakpoints: {
        1024: {
          perPage: 3,
          gap: '20px',
        },
        989: {
          perPage: 2,
          gap: '20px',
        },
        480: {
          perPage: 1,
          gap: '10px',
        },
      },
    }).mount(window.splide.Extensions);
  }
  // Index project slider

  // Testimonial slider
  const cl_testmonial = document.querySelector('#cl_testmonial');
  if (cl_testmonial){
      new Splide('#cl_testmonial', {
      type   : 'slide',
      perPage: 3,
      gap: '30px',
      arrows: true,
      pagination: false,
      pauseOnHover: false,
      breakpoints: {
        1024: {
          perPage: 3,
          gap: '20px',
        },
        989: {
          perPage: 2,
          gap: '20px',
        },
        480: {
          perPage: 1,
          gap: '10px',
        },
      },
    }).mount();
  }
  // Testimonial slider

  // Featured collection slider
  const ourproduct_slide = document.querySelector('#ourproduct_slide');
  if (ourproduct_slide){
      new Splide('#ourproduct_slide', {
      type: 'loop',
      focus: 'center',
      loop: false,
      perPage: 3,
      pauseOnHover: true,
      pauseOnFocus: true,
      gap: '30px',
      perMove: 1,
      arrows: true,
      pagination: false,
      padding: { left: '10%', right: '10%' },
      breakpoints: {
        1024: {
          perPage: 3,
          gap: '20px',
          padding: { left: '0', right: '0' },
        },
        989: {
          perPage: 2,
          gap: '20px',
          padding: { left: '0', right: '0' },
        },
        480: {
          perPage: 1,
          gap: '10px',
          padding: { left: '0', right: '0' },
        },
      },
    }).mount();
  }
  // Featured collection slider

  // Product details tab
    const tabs = document.querySelectorAll('.product__info-wrapper .tab');
    const contents = document.querySelectorAll('.product__info-wrapper .tab-content');

    if (tabs && contents){
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          // Remove active class from all tabs
          tabs.forEach(t => t.classList.remove('active'));
          // Hide all content
          contents.forEach(c => c.classList.add('hidden'));

          // Add active class to clicked tab
          tab.classList.add('active');
          // Show the corresponding content
          const target = document.getElementById(tab.dataset.tab);
          target.classList.remove('hidden');
        });
      });
    }
  // Product details tab
});